export const isNumber = (num: any): num is number => {
    return Number.isFinite(num);
};
